// Gemeinsame Aufzaehlungen. Diese Listen sind die einzige Wahrheit:
// das Drizzle-Schema und die Zod-Schemas leiten sich daraus ab.
export const GESCHLECHTER = ["m", "w", "d", "unbekannt"];
/**
 * Rolle einer Person innerhalb einer Familie.
 * Entspricht dem alten `relationen.reltyp`: 'v' -> elternteil, 'n' -> kind.
 *
 * Daraus ergeben sich alle Verwandtschaften:
 *   nur Elternteile in einer Familie  -> Partnerschaft
 *   nur Kinder                        -> Geschwister
 *   beides                            -> Eltern/Kind
 */
export const FAMILIENROLLEN = ["elternteil", "kind"];
/** Art der Verbindung. Im Altbestand ist alles 'leiblich' bzw. unbekannt. */
export const VERBINDUNGSARTEN = [
    "leiblich",
    "adoptiert",
    "stief",
    "pflege",
    "unbekannt",
];
/**
 * Welche Ebene ein Ort ist. Steuert Anzeige und spaeter die Geokodierung:
 * fuer eine Chronik ist meist die Ortschaft der richtige Kartenpunkt, nicht
 * das Haus - und bei historischen Adressen oft das Einzige, was sich
 * ueberhaupt finden laesst.
 *
 * Automatisch angelegte Orte bleiben "unbekannt"; aus einem getippten Pfad
 * laesst sich die Ebene nicht sicher raten ("Wien 3" ist ein Bezirk,
 * "Haimschlag 30" ein Haus). Gesetzt wird sie im Ortsregister.
 */
export const ORTSARTEN = [
    "land",
    "region",
    "bezirk",
    "ort",
    "adresse",
    "unbekannt",
];
export const ORTSART_LABEL = {
    land: "Land",
    region: "Bundesland / Region",
    bezirk: "Bezirk",
    ort: "Ortschaft",
    adresse: "Adresse",
    unbekannt: "unbekannt",
};
/**
 * Abweichende Namen einer Person - was NICHT der heute gefuehrte Name ist.
 *
 * Bewusst kurz. Der Rufname („Josef, genannt Pepi") steht als eigene Spalte
 * an der Person: das ist der Name, unter dem jemand taeglich lief, also eine
 * Eigenschaft des Menschen. Hier stehen die Namen, die in QUELLEN auftauchen
 * oder sich im Leben geaendert haben.
 */
export const NAMENSARTEN = ["variante", "angenommen"];
export const NAMENSART_LABEL = {
    variante: "Schreibweise",
    angenommen: "angenommener Name",
};
/** Was in der Maske unter der Auswahl steht - je Art ein Beispiel. */
export const NAMENSART_HINWEIS = {
    variante: "derselbe Name, anders geschrieben — Mayr / Maier / Meier",
    angenommen: "nach Adoption, Einheirat oder Namensänderung; auch ein Vulgoname",
};
export const EREIGNISARTEN = [
    "geburt",
    "taufe",
    "firmung",
    "schuleintritt",
    "schulabschluss",
    "berufsabschluss",
    "arbeitsbeginn",
    "pensionierung",
    "hochzeit",
    "verpartnerung",
    "scheidung",
    "hochzeitsjubilaeum",
    "wohnsitz",
    "umzug",
    "auswanderung",
    "militaerdienst",
    "tod",
    "begraebnis",
    "sonstiges",
];
/** Ereignisarten, die immer eine Familie betreffen und nicht nur eine Person. */
export const FAMILIEN_EREIGNISARTEN = [
    "hochzeit",
    "verpartnerung",
    "scheidung",
    "hochzeitsjubilaeum",
];
/** Rolle einer Person in einem Ereignis. */
export const EREIGNISROLLEN = [
    "hauptperson",
    "partner",
    "elternteil",
    "kind",
    "pate",
    "trauzeuge",
    "beteiligt",
];
/**
 * Verwandtschaft, aus der Sicht einer bestehenden Person, wenn eine neue
 * Person daneben gestellt wird. Daraus ergibt sich, in welcher Familie und
 * mit welcher Rolle beide landen:
 *
 *   elternteil    -> Familie, in der die Person KIND ist; neu = elternteil
 *   geschwister   -> dieselbe Familie;                    neu = kind
 *   partner       -> Familie, in der die Person ELTERNTEIL ist; neu = elternteil
 *   kind          -> dieselbe Familie;                    neu = kind
 */
export const VERWANDTSCHAFTSARTEN = [
    "elternteil",
    "geschwister",
    "partner",
    "kind",
];
export const VERWANDTSCHAFT_LABEL = {
    elternteil: "Elternteil",
    geschwister: "Geschwister",
    partner: "Partner",
    kind: "Kind",
};
/**
 * In welcher Rolle die BESTEHENDE Person in der betroffenen Familie steckt.
 * Bestimmt, welche Familien zur Auswahl stehen.
 */
export const ROLLE_DER_BESTEHENDEN = {
    elternteil: "kind",
    geschwister: "kind",
    partner: "elternteil",
    kind: "elternteil",
};
/** In welcher Rolle die NEUE Person in dieselbe Familie kommt. */
export const ROLLE_DER_NEUEN = {
    elternteil: "elternteil",
    geschwister: "kind",
    partner: "elternteil",
    kind: "kind",
};
/** Woran ein Medium haengen kann. */
export const MEDIENZIELE = ["person", "familie", "ereignis"];
export const BENUTZERROLLEN = ["besitzer", "bearbeiter", "betrachter"];
/** Beschriftungen fuer die Oberflaeche. */
export const EREIGNIS_LABEL = {
    geburt: "Geburt",
    taufe: "Taufe",
    firmung: "Firmung",
    schuleintritt: "Schuleintritt",
    schulabschluss: "Schulabschluss",
    berufsabschluss: "Berufsabschluss",
    arbeitsbeginn: "Arbeitsbeginn",
    pensionierung: "Pensionierung",
    hochzeit: "Hochzeit",
    verpartnerung: "Verpartnerung",
    scheidung: "Scheidung",
    hochzeitsjubilaeum: "Hochzeitsjubiläum",
    wohnsitz: "Wohnsitz",
    umzug: "Umzug",
    auswanderung: "Auswanderung",
    militaerdienst: "Militärdienst",
    tod: "Tod",
    begraebnis: "Begräbnis",
    sonstiges: "Sonstiges",
};
/** Beschriftungen der Rollen in einem Ereignis. */
export const EREIGNISROLLE_LABEL = {
    hauptperson: "Hauptperson",
    partner: "Partner",
    elternteil: "Elternteil",
    kind: "Kind",
    pate: "Pate / Patin",
    trauzeuge: "Trauzeuge / Trauzeugin",
    beteiligt: "beteiligt",
};
/**
 * Wie eine Rolle in der Ereignisliste steht.
 *
 * „Hochzeit mit Anna, Hans, Eva" ist irreführend, wenn zwei davon Trauzeugen
 * sind. Deshalb wird pro Rolle gruppiert und beschriftet — in der Einzahl
 * nach Geschlecht, weil „Trauzeuge Eva Mayr" genauso schief klingt.
 */
const ROLLENFORMEN = {
    hauptperson: { m: "mit", w: "mit", mehrzahl: "mit" },
    partner: { m: "mit", w: "mit", mehrzahl: "mit" },
    elternteil: { m: "Vater", w: "Mutter", mehrzahl: "Eltern" },
    kind: { m: "Sohn", w: "Tochter", mehrzahl: "Kinder" },
    pate: { m: "Pate", w: "Patin", mehrzahl: "Paten" },
    trauzeuge: { m: "Trauzeuge", w: "Trauzeugin", mehrzahl: "Trauzeugen" },
    beteiligt: { m: "dabei", w: "dabei", mehrzahl: "dabei" },
};
export function ereignisrolleText(rolle, anzahl, geschlecht) {
    const f = ROLLENFORMEN[rolle];
    if (anzahl > 1)
        return f.mehrzahl;
    return geschlecht === "w" ? f.w : f.m;
}
//# sourceMappingURL=typen.js.map